import * as React from 'react';

const StackedAreaChart = (): React.JSX.Element => <></>;

export default StackedAreaChart;
